import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as debug from 'debug';

@Component({
  selector: 'services-icon',
  templateUrl: 'services-icon.html',
})
export class ServicesIconComponent {
  log = debug('app:ServicesDashboardComponent');

  @Input()
  iconDisplay: string;
  svg: any;
  @Input()
  options: any;
  isFA: boolean = false;
  constructor(
    public sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.options.svg = this.sanitizer.bypassSecurityTrustHtml(this.options.svg);
    this.isFA = !!new RegExp('fa-').test(this.iconDisplay);
  }
}



// WEBPACK FOOTER //
// ./src/components/services-dashboard/icons/services-icon.ts